var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeminiToggleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42632 3.78311C1.83084 3.64827 2.14827 3.33084 2.28311 2.92632L2.51689 2.225C2.56168 2.09063 2.68742 2 2.82906 2C2.97069 2 3.09644 2.09063 3.14123 2.225L3.375 2.92632C3.50984 3.33084 3.82727 3.64827 4.2318 3.78311L4.93311 4.01689C5.06748 4.06168 5.15811 4.18742 5.15811 4.32906C5.15811 4.47069 5.06748 4.59644 4.93311 4.64123L4.2318 4.875C3.82727 5.00984 3.50984 5.32727 3.375 5.7318L3.14123 6.43311C3.09644 6.56748 2.97069 6.65811 2.82906 6.65811C2.68742 6.65811 2.56168 6.56748 2.51689 6.43311L2.28311 5.7318C2.14827 5.32727 1.83084 5.00984 1.42632 4.875L0.725 4.64123C0.590632 4.59644 0.5 4.47069 0.5 4.32906C0.5 4.18742 0.590632 4.06168 0.725 4.01689L1.42632 3.78311Z",
    fill: "url(#paint0_linear_6269_4961)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09658 1.14839C5.35711 1.06155 5.56155 0.857112 5.64839 0.596583L5.79895 0.144909C5.8278 0.0583706 5.90878 0 6 0C6.09122 0 6.1722 0.0583705 6.20105 0.144908L6.35161 0.596583C6.43845 0.857112 6.64289 1.06155 6.90342 1.14839L7.35509 1.29895C7.44163 1.3278 7.5 1.40878 7.5 1.5C7.5 1.59122 7.44163 1.6722 7.35509 1.70105L6.90342 1.85161C6.64289 1.93845 6.43845 2.14289 6.35161 2.40342L6.20105 2.85509C6.1722 2.94163 6.09122 3 6 3C5.90878 3 5.8278 2.94163 5.79895 2.85509L5.64839 2.40342C5.56155 2.14289 5.35711 1.93845 5.09658 1.85161L4.64491 1.70105C4.55837 1.6722 4.5 1.59122 4.5 1.5C4.5 1.40878 4.55837 1.3278 4.64491 1.29895L5.09658 1.14839Z",
    fill: "url(#paint1_linear_6269_4961)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49715 5.95699C5.71426 5.88462 5.88462 5.71426 5.95699 5.49715L6.08246 5.12076C6.1065 5.04864 6.17398 5 6.25 5C6.32602 5 6.3935 5.04864 6.41754 5.12076L6.54301 5.49715C6.61538 5.71426 6.78574 5.88462 7.00285 5.95699L7.37924 6.08246C7.45136 6.1065 7.5 6.17398 7.5 6.25C7.5 6.32602 7.45136 6.3935 7.37924 6.41754L7.00285 6.54301C6.78574 6.61538 6.61538 6.78574 6.54301 7.00285L6.41754 7.37924C6.3935 7.45136 6.32602 7.5 6.25 7.5C6.17398 7.5 6.1065 7.45136 6.08246 7.37924L5.95699 7.00285C5.88462 6.78574 5.71426 6.61538 5.49715 6.54301L5.12076 6.41754C5.04864 6.3935 5 6.32602 5 6.25C5 6.17398 5.04864 6.1065 5.12076 6.08246L5.49715 5.95699Z",
    fill: "url(#paint2_linear_6269_4961)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6269_4961",
    x1: 7.5,
    y1: 7.5,
    x2: 0.5,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0096EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0321A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6269_4961",
    x1: 7.5,
    y1: 7.5,
    x2: 0.5,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0096EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0321A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6269_4961",
    x1: 7.5,
    y1: 7.5,
    x2: 0.5,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0096EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0321A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeminiToggleIcon);
export default __webpack_public_path__ + "static/media/gemini_toggle_icon.535b96ad17c821ea9a237c48eea40cea.svg";
export { ForwardRef as ReactComponent };